module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/deskdouble/deskdouble.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/deskdouble/deskdouble.png
// module id = 553
// module chunks = 0